module.exports = ( $parse ) ->
  return {
    restrict: 'A'

    transclude: true
    template: require( './divLoader.html' )
    controller: ( $scope, $element, $attrs ) ->
      isLoadingGetter = $parse( $attrs.divLoader )

      $scope.isLoading = ->
        isLoadingGetter( $scope )
  }
